export enum AppCodes {
  AppCode = 'CMS-SYSTEM'
}
